export default __webpack_public_path__ + "static/media/hermes_915_3.4b0b1195.jpg";